export default __webpack_public_path__ + "scene2_4_icon07cf64.png";